<app-radio-input-group #childDiagnosisComponent [indication]="bodyWeightDiagnosisIndication" [labelName]="'Diagnosis'" [controlName]="'diagnosis'" 
 [controlDisplayName]="'Diagnosis'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedRadioControlSelectionChangedHandler($event)"></app-radio-input-group>
<div class="criteria-section" [hidden]="!showCriteriaSection()">
    <app-limits-input #childLimitsComponent [indication]="bodyWeightLimitsIndication" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedTextControlSelectionChangedHandler($event)"></app-limits-input>
</div>
<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>
